import React, { useRef, useState } from 'react'
import ImageBuffer from '../../ImageBuffer/ImageBuffer'
import {Badge, ReadMore, SubCover, SubHeader} from '../..'
import { ArrowForwardRounded } from '@mui/icons-material'
import { hero1 } from '../../../assets'

import './about.css'

const About = () => {
    const modalNavRef                             = useRef<HTMLDivElement | null>(null);
    const [openSubMegaMenu, setOpenSubMegaMenu]   = useState<number | null>(null);
    const [toggleResult, setToggleResult]         = useState<boolean>(false);

    const handleToggleAboutMore = (index: number) => {
        setToggleResult(true)
        setOpenSubMegaMenu(prev => (prev === index ? null : index));
    }

    const handleCloseCover = () => {
        setToggleResult(false)
        setOpenSubMegaMenu(null);
    }
    
    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (modalNavRef.current === e.target) {
            closeAboutModal();
        }
    };

    const closeAboutModal = () => {
        setToggleResult(false);
        setOpenSubMegaMenu(null);
    };

  return (
    <>
        <div id="about" className='about-wrapper'>
            <Badge title="About Us" />
            <SubHeader title="" description="" />
            <div className="about-container">
                <div className="about-main-box-image-cover">
                    <ImageBuffer className="about-main-box-image" src={hero1} alt="" />
                </div>
                <div className="about-main-box">
                    <h1 className="about-main-description">About Us</h1>
                    <div className="about-main-gradient"></div>
                    <p className="about-main-8">A1Care Licensed Home Health Agency is a healthcare provider dedicated to delivering holistic, patient-centered services. Our offerings include Primary Care, Mental Health Services, Psychotherapy, and Substance Use and Addiction Counseling. Through our residential services division, we also provide both skilled and non-skilled nursing care to meet diverse patient needs.</p>
                    <button className="about-main-read-more-btn-cover" onClick={() => handleToggleAboutMore(1)}>
                        <span>Read more</span>
                        <ArrowForwardRounded />
                    </button>
                    <ReadMore onOpen={toggleResult} onClose={closeAboutModal} openSubMegaMenu={openSubMegaMenu} />
                </div>
            </div>
        </div>
        {openSubMegaMenu !== null && (
            //z-index: 3, others should be higher
            <SubCover handleCloseCover={handleCloseCover} />
        )}
    </>
  )
}

export default About